import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=18cd75df"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports